
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { LeaderboardItem } from "./types";

interface LeaderboardCardProps {
  item: LeaderboardItem;
  filterType: "product" | "industry";
}

const LeaderboardCard = ({ item, filterType }: LeaderboardCardProps) => {
  return (
    <Card className="bg-slate-800 border-slate-700 shadow-xl hover:shadow-2xl transition-shadow">
      <CardContent className="p-0">
        <div className="p-2 border-b border-slate-700">
          <div className="text-xs font-bold mb-1 line-clamp-1">
            {item.accountName ? `${item.accountName} (${item.name})` : item.name}
          </div>
          <div className="text-[10px] text-slate-400 line-clamp-1">
            {item.region}{item.country ? `, ${item.country}` : ''} - {filterType === "product" ? item.productLine : item.industry}
          </div>
        </div>
        <div className="p-2">
          <div className="flex justify-between mb-2 text-[10px]">
            <div className="flex justify-between w-full">
              <span className="text-slate-400">Achievement</span>
              <span className="font-semibold">${item.achievement.toLocaleString()}</span>
            </div>
          </div>
          <div className="flex justify-between mb-2 text-[10px]">
            <div className="flex justify-between w-full">
              <span className="text-slate-400">Target</span>
              <span className="font-semibold">${item.target.toLocaleString()}</span>
            </div>
          </div>
          <div className="relative overflow-hidden rounded-full h-2 bg-slate-700 mt-2">
            <div className={`h-full rounded-full ${
              item.percentage && item.percentage >= 100 
                ? 'bg-emerald-500' 
                : item.percentage && item.percentage >= 85 
                  ? 'bg-orange-500' 
                  : 'bg-red-500'
            }`} style={{
              width: `${item.percentage && item.percentage > 100 ? 100 : item.percentage}%`
            }}></div>
            <div className="absolute inset-0 flex items-center justify-center text-[11px] font-semibold">
              {item.percentage}%
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default LeaderboardCard;
